import React from "react";
import { Field, FieldInputProps, FieldRenderProps } from "react-final-form";
import { FormControlLabel } from "@mui/material";
import Radio, { RadioProps as MuiRadioProps } from "@mui/material/Radio";
import { FieldValidator } from "final-form";

type RadioFieldProps = Partial<Omit<MuiRadioProps, "onChange">> & {
  name: string;
  label?: string;
  "data-testid"?: string;
  value: string;
  fieldProps?: Partial<FieldInputProps<boolean, HTMLInputElement>>;
  validate?: FieldValidator<string | boolean>;
};

const RadioField: React.FC<RadioFieldProps> = (props: RadioFieldProps) => {
  const { fieldProps, label, name, validate, value, ...rest } = props;
  return (
    <Field
      name={name}
      render={({ input, meta }) => <RadioWrapper input={input} meta={meta} name={name} value={value} label={label} {...rest} />}
      type="radio"
      value={value}
    />
  );
};

type RadioWrapperProps = FieldRenderProps<string, HTMLElement> & {
  label?: string;
  "data-testid"?: string;
};

const RadioWrapper: React.FC<RadioWrapperProps> = ({ input, label, disabled, "data-testid": dataT, size, value }: RadioWrapperProps) => {
  return <FormControlLabel value={value} control={<Radio {...input} size={size} disabled={disabled} />} label={label} data-testid={dataT} />;
};

export default RadioField;
